/* Cesta del restyling: «Completa con» con las reglas de la sección de la cesta, para los primeros productos de la
   cesta (la regla de cada uno se calcula en Liquid): más vendidos de las colecciones de la regla, primero los del mismo
   color y sin los del mismo tipo que el producto. Sin repetir ni mostrar lo que ya está en la cesta. */
(function () {
  if (window.__wimCartBound) return;
  window.__wimCartBound = true;

  var RECS_SECTION = "wim-cart-recs";
  var cache = {};

  function items(url) {
    if (!cache[url]) {
      cache[url] = fetch(url)
        .then(function (response) { return response.ok ? response.text() : ""; })
        .then(function (html) {
          var box = new DOMParser().parseFromString(html, "text/html").querySelector("[data-wim-ck-recs]");
          return box ? Array.from(box.querySelectorAll("[data-product-id]")) : [];
        })
        .catch(function () { return []; });
    }
    return cache[url];
  }

  /* Por orden: cada colección con filtro y color; con «Completar con otros colores», después cada una solo con el filtro */
  function ruleUrls(source, fill) {
    var query = "?section_id=" + RECS_SECTION + "&sort_by=best-selling";
    var urls = (source.getAttribute("data-urls") || "").split("|").filter(Boolean);
    var filter = source.getAttribute("data-filter");
    var color = source.getAttribute("data-color-handle");
    var tagged = function (tags) { tags = tags.filter(Boolean); return tags.length ? "/" + tags.join("+") : ""; };
    var list = urls.map(function (url) { return url + tagged([filter, color]) + query; });
    if (fill) list = list.concat(urls.map(function (url) { return url + tagged([filter]) + query; }));
    return list;
  }

  async function fill(section) {
    if (section.hasAttribute("data-wim-ck-ready")) return;
    section.setAttribute("data-wim-ck-ready", "");

    var limit = parseInt(section.getAttribute("data-limit") || "3", 10);
    var sources = Array.from(section.querySelectorAll("[data-wim-ck-src]"));
    if (!sources.length) return;

    var seen = {};
    var picked = [];
    (section.getAttribute("data-product-ids") || "").split(",").filter(Boolean).forEach(function (id) { seen[id] = true; });

    for (var i = 0; i < sources.length && picked.length < limit; i++) {
      var type = sources[i].getAttribute("data-type");
      var urls = ruleUrls(sources[i], section.hasAttribute("data-rule-fill"));
      for (var j = 0; j < urls.length && picked.length < limit; j++) {
        (await items(urls[j])).forEach(function (item) {
          var id = item.getAttribute("data-product-id");
          if (picked.length >= limit || seen[id]) return;
          if (type && item.getAttribute("data-type") === type) return;
          seen[id] = true;
          picked.push(document.importNode(item, true));
        });
      }
    }

    if (!picked.length || !section.isConnected) return;
    var list = section.querySelector("[data-wim-ck-xsl]");
    list.replaceChildren.apply(list, picked);
    section.hidden = false;
  }

  function scan() {
    document.querySelectorAll("cart-drawer [data-wim-ck-xs]").forEach(fill);
  }

  /* Se cargan al abrir la cesta y cada vez que la cesta se vuelve a pintar; dialog:before-show no burbujea */
  document.addEventListener("dialog:before-show", function (event) {
    if (event.target.matches && event.target.matches("cart-drawer")) scan();
  }, true);

  document.addEventListener("cart-drawer:refreshed", scan);
})();
